import React from 'react';
import { TextButton as Button } from '@oneaudi/unified-web-components';
import { VendorCtaSelectorProps } from './VendorCtaSelector';

const CustomCta = ({ ctaDetails, variant, vin }: VendorCtaSelectorProps) => {
  const {
    ctaVendorLink,
    ctaVendorTarget,
    ctaVendorButtonLabel,
    ctaVendorCustomId,
    ctaVendorAdditionalClasses,
    ctaVendorSeoAttributes,
  } = ctaDetails;
  return (
    <Button
      variant={variant}
      href={ctaVendorLink ?? '#'}
      target={ctaVendorTarget}
      key={`key_${ctaVendorButtonLabel}`}
      id={ctaVendorCustomId}
      className={ctaVendorAdditionalClasses}
      data-seo={ctaVendorSeoAttributes}
      data-vin={vin}
      data-testid="custom"
    >
      {ctaVendorButtonLabel}
    </Button>
  );
};

export default CustomCta;
